export const caseStudiesData = [
  {
    id: 1,
    title: "Oxfordshire Detached Home: Heat Pump Sizing",
    category: "Residential",
    location: "Oxfordshire, UK",
    buildingType: "Detached House",
    size: "120m²",
    challenge: "Homeowner planning heat pump installation needed accurate heat loss data to size the system correctly and avoid oversizing.",
    solution: "Rebel sensor deployed on existing fossil fuel boiler for winter conditions. Real-time monitoring captured actual heat demand patterns across different outdoor temperatures.",
    description: "Initial deployment in a typical detached house revealed real-time boiler cycling patterns and heat demand profiles, providing accurate data for heat pump sizing calculations.",
    images: [
      "/heating_scatter.png", "/heating_runtime_scatter.png"
    ],
    results: [
      "5kW peak heat loss measured at -2°C outdoor temperature",
      "Boiler Temperature never exceeded 45°C, indicating low-temperature heating system compatibility",

    ],
    keyMetrics: [
      { label: "Heat Loss @ -2°C", value: "5kW" },
      { label: "Monitoring Period", value: "365 days" },
      { label: "Data Points", value: "millions" },
    ],
    previewMetrics: [
      { label: "Heat Loss @ -2°C", value: "5kW" },
      { label: "Max Flow Temp", value: "45°C", subtitle: "Low-temperature ready" }
    ],
    // testimonial: {
    //   quote: "Having real data from my own boiler made the decision to go ahead with a heat pump so much easier. No guesswork, just facts.",
    //   author: "Homeowner",
    //   role: "London"
    // }
  },
  {
    id: 2,

    title: "200 Year Old Church: Heat Pump Install Complete",
    category: "Ecclesiastical",
    location: "Hampshire, UK",
    buildingType: "Historic Church",
    size: "250m²",
    challenge: "Proving the viability of a heat pump in a large, old church building with high heat loss and limited insulation. Churches use intermittent heating patterns - only heating for services and events rather than continuously. Traditional steady-state heat loss calculations are inappropriate for intermittent heating use cases.",
    solution: "Rebel sensor installed to monitor church heating system performance 24/7. We modelled the thermal mass of the historic building and captured real intermittent heating patterns to understand actual heating requirements. Unlike steady-state calculations that assume constant heating, our data-driven approach captured the building's thermal behavior during warm-up periods and services with its existing fossil heater.",
    description: "Cloud-connected sensor installed to monitor church heating system performance 24/7. Platform provided real-time feedback for the church wardens. Successful heat pump installation demonstrating viability for heritage church buildings.",
    images: [
      "/church_running_costs.jpg", "/church.jpeg",  "/church2.jpg"
    ],
    results: [
      "52kW Peak Heat Power installed",
      "Heat pump successfully sized and installed in historic church based on real intermittent heating data, not steady-state assumptions",
      "Church now operates with zero carbon heating - Scope 1 emissions reduced to zero",
      "Accurate sizing prevented undersizing and inflated running costs from extended heating periods",
      "Thermal mass modeling ensured adequate warm-up capacity for services"
    ],
    keyMetrics: [
      { label: "Building Age", value: "200 years" },
      { label: "Building Size", value: "250m²" },
      { label: "Monitoring", value: "24/7" },
      { label: "Heat Pump Size", value: "52kW" }
    ],
    previewMetrics: [
      { label: "Church Age", value: "200 years" },
      { label: "Zero Carbon", value: "Heating" }
    ],
    // testimonial: {
    //   quote: "We discovered our heating was running unnecessarily outside service hours. The data has been invaluable for understanding our system.",
    //   author: "Church Warden",
    //   role: "Northamptonshire"
    // }
  }
];
